
export default { 
 common: { 
 unit: 'USDT', 
 day: 'dies', 
 week: 'hebdomas', 
 save: 'servare', 
 submit: 'mittere', 
 confirmtitle: 'confirmare operationem', 
 confirm: 'confirmare', 
 reset: 'reinitiare', 
 refresh: 'refrigerare', 
 copy: 'copiare', 
 copysuccessful: 'copia feliciter facta', 
 modify: 'modificare', 
 binding: 'ligare', 
 finished: 'perfectum', 
 canceled: 'cancellatum', 
 cancel: 'cancellare', 
 all: 'omnes', 
 back: 'redire', 
 loading: 'incargando...', 
 nomore: 'omnia recorda', 
 errortxt: 'incargatio aborta', 
 loosing: 'laxare ut refrigerare...', 
 pulling: 'tractare ut refrigerare...', 
 nodata: 'momentaneamente nulla recorda', 
 buy: 'emere', 
 buyup: 'emere ascensum', 
 buydown: 'emere descensum', 
 sell: 'vendere', 
 forserver: 'consultere servatorem', 
 total: 'totalis', 
 status1: 'in spe ', 
 status2: 'perfectum ', 
 status3: 'reprobatum', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'telegraphicum transfertum', 
 }, 
 footer: { 
 home: 'domus', 
 market: 'mercatura', 
 exchange: 'nummus-nummus', 
 options: 'optio', 
 assets:'asset', 
 change: 'transferre', 
 recharge: 'nummus implere', 
 withdrawal: 'nummus extrahere' 
 }, 
 home: { 
 menu1:'optio commercium', 
 menu1desc: 'supportare BTC/USDT etc.', 
 menu2: 'nummus celeriter implere', 
 menu3: 'nummus extrahere', 
 menu4: 'servator in situ', 
 menu5: 'instantanea conversio', 
 menu6: 'auxilium praestare', 
 menu7: 'vasare et minare', 
 menu8: 'obligare', 
 menu9: 'nummus transferre', 
 ranktitle: 'gradus augmenti', 
 name: 'nomen', 
 price: 'novissimus pretium', 
 risefall: 'auctus-declinatio', 
 }, 
 register: { 
 register: 'registrare', 
 login: 'ingressare', 
 email: 'Email', 
 phone: 'telefonum', 
 accountplaceholder: 'inputare numerum', 
 emailplaceholder: 'inputare casulam electronicam', 
 phoneplaceholder: 'inputare numerum telefonici', 
 pwdplaceholder:'inputare tesseram', 
 pwdplaceholder1:'tessera est litterarum numerorumque arbitrarium 6-20', 
 agepwdplaceholder: 'iterum inputare tesseram', 
 agepwdplaceholder1: 'duae tesserae non identicae', 
 invitecodeplaceholder: 'inputare codicem invitationis', 
 remember: 'tessera meminisse', 
 fotget: 'tesseram oblivisci' 
 }, 
 market:{ 
 title: 'mercatura', 
 all: 'omnia' 
 }, 
 member:{ 
 reputation:'fama', 
 identity_authentication:'identitatis authentificatio', 
 under_review:'sub revisa', 
 certified:'certificatum', 
 awaiting_certification:'in expectatione certificationis', 
 binding_withdrawal_address: 'obligare extrahendi nummi locum', 
 currently_selected_currency:'nummus selectus nunc', 
 withdrawal_address:'extrahendi nummi locum', 
 sharing_link:'meus nexus communicans', 
 my_promotion_code:'meus codex promotionis', 
 promotion_code:'codex promotionis', 
 system_message:'nuntius systematis', 
 night_mode:'nocturna modus', 
 security_center:'centrum securitatis', 
 seted: 'constitutum', 
 noset: 'non constitutum', 
 login_password:'tessera ingressus', 
 transaction_password:'tessera transactionis', 
 app_download:'applicare descicere', 
 log_out:'egressus', 
 aboutus: 'de nobis' 
 }, 
 identity:{ 
 title: 'identitas authentificatio', 
 name: 'nomen', 
 nameplaceholder: 'inputare verum nomen', 
 uploader: 'uploadare photographiam identitatis', 
 tip1: 'uploadare faciem identitatis', 
 tip2: 'uploadare reversum identitatis' 
 }, 
 address: { 
 title: 'obligare extrahendi nummi locum', 
 bType: 'nummus selectus nunc', 
 address: 'extrahendi nummi locum', 
 addressplaceholder:'inputare extrahendi nummi locum', 
 }, 
 security:{ 
 title: 'centrum securitatis', 
 modifypwd: 'tessera ingressus', 
 resetlegalpwd: 'tessera transactionis', 
 loginpwd: 'nova tessera ingressus', 
 pwdage: 'tessera confirmare', 
 loginpwdplaceholder:'inputare tesseram ingressum praesens', 
 loginnewpwdplaceholder: 'inputare novam tesseram ingressum', 
 moneypwd: 'inputare tesseram transactionis', 
 pwdageplaceholder:'iterum inputare tesseram' 
 }, 
 trade:{ 
 title: 'nummus-nummus commercium', 
 price: 'pretium', 
 num: 'numerus', 
 entrust: 'commissionem praesens', 
 clinch: 'commercium perfectum', 
 used: 'uti', 
 buyed: 'emere potest', 
 amount: 'quantum', 
 limitprice: 'pretium limitatum', 
 marketprice: 'pretium mercato', 
 forprice: 'commercium cum optimo pretio praesenti', 
 errorMoney: 'nummus uti insufficiens', 
 priceerror: 'inputare pretium commissionis', 
 numerror: 'inputare numerus commissionis', 
 moneyerror: 'inputare summa commissionis', 
 }, 
 assets:{ 
 allconvert:'totalis assets conversus', 
 usenum: 'uti', 
 freeze: 'gelare', 
 convert: 'convertere', 
 tab1:'assets', 
 tab11: 'totalis assets conversus', 
 tab12: 'optio conversus', 
 tab13: 'pecunia conversus', 
 tab14: 'quantitas conversus', 
 tab2:'optio', 
 tab21: 'optio numerus', 
 tab3:'pecunia', 
 tab31:'pecunia numerus', 
 tab4:'quantitas', 
 tab41:'quantitas numerus', 
 tbhead1: 'record pecuniarius', 
 tbhead2: 'record extrahendi nummi', 
 tbhead3: 'record implendi nummi', 
 tbhead4: 'record transferri nummi', 
 rcdnum: 'numerus', 
 rcd: 'record', 
 rcdtime: 'tempus' , 
 rcdstatus: 'status', 
 rcddesc: 'nota', 
 rcdaddress: 'locus implendi nummi' 
 }, 
 change:{ 
 title: 'transferre', 
 from: 'a {name}', 
 to: 'ad {name}', 
 frmtitle: 'numerus transferri', 
 inputplaceholder: 'inputare numerus transferri', 
 btntxt:'transferre' 
 }, 
 recharge:{ 
 title: 'nummus implere', 
 bType: 'nummus praesens', 
 address: 'locus implendi nummi', 
 token: 'voucher', 
 tokenplaceholder: 'uploadare voucher', 
 num: 'numerus impletionis', 
 numplaceholder: 'inputare numerus', 
 btn: 'mittere ad examinandum', 
 bankname: 'nomen bancae', 
 bankno: 'numerus bancae', 
 accountname: 'nomen receptionis', 
 bankaddress: 'locus bancae', 
 bankcode: 'codicem bancae', 
 companyaddress: 'locus societatis' 
 }, 
 withdrawal:{ 
 title:'nummus extrahere', 
 frmtitle1: 'numerus', 
 frmplaceholder1: 'numerus extrahendi nummi inter {min} - {max}', 
 frmtitle2: 'tessera transactionis', 
 frmplaceholder2: 'inputare tesseram transactionis', 
 getnum: 'numerus receptus', 
 fee:'merces', 
 btn: 'extrahere nummum' 
 }, 
 exchangeb:{ 
 title: 'convertere', 
 account: 'numerus', 
 btn: 'convertere', 
 numerror: 'inputare numerus conversionis' 
 }, 
 option:{ 
 title: 'optio', 
 typetitle: 'contractus momentaneus', 
 listtitle: 'positiones', 
 kline: 'K-linea', 
 high: 'altus', 
 low: 'bassus', 
 nums: 'quantitas 24H', 
 time: 'tempus', 
 transaction: 'modus commercii', 
 quantity: 'numerus positionis', 
 quantityerror: 'inputare numerus positionis', 
 times: 'tempus positionis', 
 times1: 'tempus Solutionis',
 account: 'saldo', 
 buyup:'emere ascensum', 
 buydown: 'emere descensum', 
 tab1: 'lista positionum', 
 tab2: 'record ordinis', 
 num: 'numerus', 
 price1: 'pretium emptionis', 
 price2: 'pretium venditae', 
 profitandloss: 'profitum et damnum praevidere', 
 profitandloss1: 'profitum et damnum', 
 countdown: 'computare retro', 
 waitfinish: 'in expectatione liquidationis', 
 finishing: 'in liquidatione...', 
 finished: 'liquidatum', 
 order_price: 'pretium praesens', 
 order_cycle: 'ciclus', 
 order_type: 'genus', 
 order_money: 'pecunia', 
 order_time: 'constructio positionis', 
 order_get: 'lucrum', 
 order_btn: 'iterum creare ordinem' 
 }, 
 tradelst:{ 
 title: 'mea commissa', 
 tab1: 'commissio', 
 tab2: 'commercium perfectum', 
 tab3: 'revocatum', 
 usdtnum: '' 
 }, 
 loans:{ 
 title: 'auxilium praestare', 
 order_tab: 'ordinis praestiti', 
 pro_tab: 'productus praestiti', 
 
 Institution:'institutio praestans', 
 Amount: 'quantitas', 
 DailyInterest:'interessus diurnus', 
 RepaymentPeriod:'periodus restitutionis', 
 Application: 'applicare praestiti', 
 orderno: 'numerus ordinis', 
 AllInterest: 'totalis interessus', 
 RepaymentDate:'dies restitutionis', 
 RepaymentMethod: 'modus restitutionis', 
 Onetime: 'simul', 
 Expected_loan_amount:'quantitas crediti expectata', 
 Expected_loan_amounterror:'quantitas crediti inter {min} - {max}', 
 imgplaceholdr: 'creditum dare (video clarum esse oportet)', 
 icon1: 'uploadare fasciculum anversum', 
 icon2: 'uploadare fasciculum reversum', 
 icon3: 'uploadare fasciculum manu tenens', 
 status1: 'in spe', 
 status2: 'approbatum', 
 status3: 'reprobatum', 
 }, 
 lockming:{ 
 title: 'vasare et minare', 
 order_tab: 'ordinis vasari', 
 pro_tab: 'mercatus vasari', 
 locknum: 'numerus minimum vasandi', 
 getforday: 'redditus/dies', 
 days: 'dies', 
 estimation: 'redditus aestimatus', 
 real: 'redditus factus', 
 balance: 'saldo cassidilis', 
 nums: 'numerus vasandi', 
 tolockming: 'vasare', 
 stime: 'tempus initio', 
 etime: 'tempus fine', 
 }, 
 transfer:{ 
 title: 'nummus transferre', 
 searchtxt: 'inputare numerum alterius', 
 ReceivingAccount: 'informatio receptionis', 
 toaccount: 'numerus', 
 confirmtxt: 'cliquere ad confirmare numerum receptionis', 
 confirmedtxt: 'numerum receptionis confirmatum', 
 numtxt: 'numerus transferri', 
 numerror: 'inputare numerus transferri', 
 fee: 'merces interna transferri nulla', 
 ArrivalTime: 'tempus adventus', 
 Immediately: 'adventus immediatus', 
 realnum: 'numerus adventus factus', 
 btn: 'confirmare transferrem', 
 
 transfering: 'transferens', 
 orderNo: 'numerus ordinis', 
 stime: 'tempus transferri', 
 etime: 'tempus adventus', 
 receiving: 'numerus receptionis', 
 type: 'nummus', 
 num: 'numerus transferri', 
 arrivalnum: 'numerus adventus' 
 }, 
 staking:{ 
 title: 'obligare', 
 record: 'record', 
 getforyear: 'redditus annuus referens', 
 time: 'terminus investitionis', 
 snum: 'numerus minimum investendi', 
 snumerror: 'inputare numerus investendi', 
 snumerror1: 'numerus investendi non minus {num}', 
 join: 'participare statim', 
 opentime: 'tempus initiandi positionis', 
 money: 'pecunia investita', 
 days: 'ciclus', 
 recordget: 'redditus annuus', 
 gets: 'redditus', 
 stime: 'dies initio', 
 etiem: 'dies fine', 
 redeemStaking: 'redemere', 
 status0: 'in obligatione', 
 status1: 'terminus ordinis', 
 status2: 'redemptio ordinis', 
 }, 
 bank:{ 
 title: 'obligare cassidilem', 
 bankName: 'nomen bancae', 
 bankNameError: 'inputare nomen bancae', 
 usrName: 'titularis', 
 usrNameError: 'inputare titulum', 
 cardCode: 'numerus cassidilis', 
 cardCodeError: 'inputare numerum cassidilis', 
 towallet: 'nummus extrahere ad cassidilem', 
 tobank: 'nummus extrahere ad bancam', 
 sendcode: 'mittere codicem', 
 sended: '{num} secunda postea mittere iterum', 
 verify_code: 'inputare codicem electronicam' 
 } 
}
